var _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 15.7733C13.8983 15.4475 14.5492 15.42 15.1125 15.6366C15.5825 15.8175 16.12 15.6675 16.4392 15.2783C17.0083 14.5841 17.4675 13.7966 17.79 12.9408C17.9742 12.4516 17.8 11.9141 17.4008 11.5758C16.9517 11.1975 16.6667 10.6341 16.6667 9.99996C16.6667 9.36579 16.9517 8.80246 17.4 8.42246C17.7992 8.08413 17.9742 7.54746 17.7892 7.05746C17.4667 6.20246 17.0083 5.41413 16.4383 4.71996C16.1192 4.33079 15.5817 4.18079 15.1117 4.36163C14.5492 4.57996 13.8983 4.55246 13.3333 4.22663C12.7667 3.89913 12.4167 3.34663 12.325 2.74746C12.25 2.25746 11.8617 1.86579 11.3725 1.78246C10.9258 1.70663 10.4675 1.66663 10 1.66663C9.53251 1.66663 9.07418 1.70663 8.62751 1.78246C8.13835 1.86579 7.75085 2.25746 7.67501 2.74746C7.58335 3.34663 7.23335 3.89913 6.66668 4.22663C6.10168 4.55246 5.45085 4.57996 4.88751 4.36246C4.41751 4.18163 3.88001 4.33163 3.56085 4.72079C2.99168 5.41496 2.53335 6.20246 2.21085 7.05829C2.02585 7.54746 2.20085 8.08496 2.60001 8.42246C3.04835 8.80246 3.33335 9.36579 3.33335 9.99996C3.33335 10.6341 3.04835 11.1975 2.60001 11.5775C2.20085 11.9158 2.02585 12.4525 2.21085 12.9425C2.53335 13.7975 2.99168 14.5858 3.56168 15.28C3.88085 15.6691 4.41835 15.8191 4.88835 15.6383C5.45085 15.42 6.10168 15.4475 6.66668 15.7733C7.23335 16.1008 7.58335 16.6533 7.67501 17.2525C7.75001 17.7425 8.13835 18.1341 8.62751 18.2175C9.07418 18.2933 9.53251 18.3333 10 18.3333C10.4675 18.3333 10.9258 18.2933 11.3725 18.2175C11.8617 18.135 12.25 17.7433 12.325 17.2525C12.4167 16.6533 12.7667 16.1008 13.3333 15.7733Z",
    fill: "#C8C8C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3.3,
    fill: "url(#g1_set)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_set",
    x1: 10,
    y1: 6.7,
    x2: 10,
    y2: 13.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDefault);
export default __webpack_public_path__ + "static/media/settings-default.37b974e1acd41b17818bd83a7a08bd0c.svg";
export { ForwardRef as ReactComponent };